import Event from 'ol/events/Event';

/** @typedef {string} TranslateEventType */

/**
 * Enum for the translate event types.
 *
 * @readonly
 * @enum {TranslateEventType}
 */
export const TranslateEventType = {
  TRANSLATE_START: 'translatestart',
  TRANSLATING: 'translating',
  TRANSLATE_END: 'translateend'
};

/**
 * Events emitted by {ol.TranslateInteraction} and {@link TranslateByHandleInteraction} instances are instances of this type.
 *
 * @class
 */
export class TranslateEvent extends Event {

  /**
   * @param {TranslateEventType} type - Type.
   * @param {Collection<ol.Feature>} features - The features translated.
   * @param {ol.Coordinate} coordinate - The event coordinate.
   * @param {ol.Coordinate} startCoordinate - The original coordinates before.translation started
   * @param {ol.MapBrowserEvent} mapBrowserEvent - Map browser event.
   */
  constructor (type, features, coordinate, startCoordinate, mapBrowserEvent) {
    super(type);

    this.features = features;
    this.coordinate = coordinate;
    this.startCoordinate = startCoordinate;
    this.mapBrowserEvent = mapBrowserEvent;
  }

}
